import axios from "axios";
import AuthProvider from "../../../../../common/authentication/authService";
import { DEPLOY_COURSE_INSTANCE_API, GET_EMAIL_TEMPLATES_API, UPDATE_COURSE_INSTANCE_API } from "../../../../../common/apiEndPoint/apiEndPoint";
import config from "../../../../../common/authentication/config";

const SITE_ID = config.SITE_ID;

export const cookieVal = () => {
  const cookie = AuthProvider().getCookie("XSRF-TOKEN");
  if (cookie !== "") {
    return cookie;
  }
};

export const deployCourseInstance = async (requestParams: any) => {
 try {
    const res: any = await axios.post(
      `${DEPLOY_COURSE_INSTANCE_API}`, requestParams,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          "X-XSRF-TOKEN": cookieVal(),
          Accept: "application/json",
          SiteId: SITE_ID
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateCourseInstance = async (requestParams: any) => {
 try {
    const { instanceId, ...payloadData } = requestParams || {};
    const res: any = await axios.put(
      `${UPDATE_COURSE_INSTANCE_API}/${instanceId}`, 
      payloadData,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          "X-XSRF-TOKEN": cookieVal(),
          Accept: "application/json",
          SiteId: SITE_ID
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const getEmailTemplatesAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_EMAIL_TEMPLATES_API}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};